import React, { useState, useEffect } from 'react'
import moment from 'moment';
import styled from 'styled-components';

// Antd
import Table from '../Utils/Table';
import { Tooltip, DatePicker } from 'antd';

// Metodos de firebase
import {
    getDataProgramacion, getDataById, verifyProgramacionById,
    deleteRecordProgramacion, deletePositionProgramacion, deleteProgramacionDia,
    bitacoraElim, openNotificationWithIcon
} from './firebaseMethods';

// Modals
import ConfirmationWithOptions from '../Utils/Modals/ConfirmationWithOptions';

// Img
import iconDelete from '../../img/Iconos/iconDelete.svg';

const programacionCrud = ({ }) => {

    // ==> States <== //
    const [refreshData, setRefreshData] = useState([]); // Verify refresh data
    const [dataDB, setDataDB] = useState([]); // Data obtain from DB
    const [dataSource, setDataSource] = useState([]); // Data table
    const [loading, setLoading] = useState(false); // Loading table

    const [showModal, setShowModal] = useState(false); // Band show modal
    const [record, setRecord] = useState({}); // Selected record data
    const [loadingBtn, setLoadingBtn] = useState(false); // Loading Btn Modal

    const [dateFilter, setDateFilter] = useState(); // Save filter date

    const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Save record checkeds

    // Obtain data and state save
    const fetchData = async (fecha, close) => {
        setLoading(true);
        const fechaFilter = close ? null : fecha ? fecha : dateFilter;
        const result = await getDataProgramacion(fechaFilter);
        const { ok, dataResult } = result;
        if (ok) {
            setDataDB(dataResult);
        };
        setLoading(false);
    }

    // Get data form DB
    useEffect(() => {
        fetchData();
    }, [refreshData]);

    // Formate data obtain DB
    useEffect(() => {
        getFormattedData();
    }, [dataDB]);


    // Method for Formate data obtain DB
    const getFormattedData = async () => {
        setLoading(true); // Loading table

        // Filtrar solo estado "Pendientes" && mayor al dia actual
        const dataFilter = (dataDB || []).filter((item) => {
            const { fecha, estado } = item[1];

            const fechaDate = new Date(fecha);
            const today = new Date(Date.now());

            if (+fechaDate > +today && estado == "Pendiente") {
                return item;
            }
        });

        // Mapear Data
        const formatted = (dataFilter || []).map(async (item) => {

            // return item;
            const key = item[0];
            const { estado, fecha, horaInicio, horaLlegada, centroC,
                programacionF: { tipo }, rutaF: { orden }, programacion } = item[1];

            // Obtain data Centro de costos
            const dataCento = await getDataById('CentroCosto', centroC);

            const sendData = {
                id: key,
                estado: estado,
                fecha: fecha,
                horaInicio: horaInicio ? horaInicio : '--',
                horaLlegada: horaLlegada ? horaLlegada : '--',
                tipoViaje: tipo ? obtainTipoViaje(tipo, fecha, horaInicio) : '--',
                centroCostos: dataCento[centroC].codigo ? dataCento[centroC].codigo : '--',
                tipoTrayecto: orden ? 'Recogimiento' : 'Reparto',
                idProgramacion: programacion
            }
            return sendData;
        });

        const resData = await Promise.all(formatted);

        setDataSource(resData); // Save data
        setLoading(false); // Loading table
    }

    // Disabe date before today
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    // Onchange Datepicker, Save date selected
    const onChangeDatePicker = (date) => {
        if (date) {
            const fecha = new Date(date);
            fecha.setHours(0);
            fecha.setMinutes(0);
            fecha.setSeconds(0);
            setDateFilter(fecha.toString());
            fetchData(fecha.toString(), false); // Get data, date to String
        } else {
            // "X" en Datepicker
            setDateFilter(null);
            fetchData(null, true); // Get data, date to String
        }

    }

    // Formato de fecha, mostrar en tabla
    const getFormattedDate = (dateMoment) => {
        const date = dateMoment ? moment(dateMoment).format('YYYY-MM-DD') : '-';
        return date;
    }

    const getFormattedHours = (hour) => {
        const hora = hour ? (hour.length == 4) ? `${hour}0` : hour : '-';
        return hora;
    }

    // Eliminar registro de programacion
    const deleteProgramacionRecord = async (item) => {
        const data = item ? item : record;

        setLoadingBtn(true); // Loading btn Modal
        const resVerifyProg = await verifyProgramacionById(data.idProgramacion);

        const { ok: okVerifyProg, varios, keyRecord,
            programacionDia, fechas
        } = resVerifyProg;

        let eliminar = false;

        if (okVerifyProg) {
            // Verificar si eliminar todo el registro
            // o solo una posicion
            if (varios) {
                const res = await deletePositionProgramacion(data, programacionDia, fechas);
                if (res.ok) eliminar = true;
            } else {
                const res = await deleteRecordProgramacion(data.idProgramacion);
                if (res.ok) eliminar = true;
            }

            if (eliminar) await deleteProgramacionDia(data.id);
            await bitacoraElim(data); // Save log
            fetchData(); // Refresh data
        }
        setLoadingBtn(false); // Loading btn Modal
        setShowModal(false); // Hide Modal
    }


    // Obtener tipo de viaje, para mostras en tabla
    const tipoDeViaje = (data) => {
        if (data !== undefined && data !== '', data !== null) {
            switch (data) {
                case 'pilotos':
                    return 'PO'
                case 'pilotossap':
                    return 'PA'
                case 'tcs':
                    return 'TCO'
                case 'tcssap':
                    return 'TCA'
                case 'persTierr':
                    return 'PTO'
            }
        } else {
            return '---';
        }
    }


    // Obtener numero tipo viaje
    const obtainTipoViaje = (data, fechaDb, horaInicioItinerada) => {
        const fecha = new Date(fechaDb);
        let sub = '' + fecha.getFullYear() + '';
        sub = sub.substring(2, 4);
        let tipoViaje = tipoDeViaje(data);
        tipoViaje = tipoViaje !== undefined ? tipoViaje : '';
        tipoViaje = tipoViaje + " " + fecha.getDate() + (fecha.getMonth() + 1) + sub;
        let hora = horaInicioItinerada;
        let splitH = hora.split(':');
        hora = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
        let militar = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HHmm');
        tipoViaje = tipoViaje + ' ' + militar;

        return tipoViaje;
    }

    const columns = [
        {
            title: 'Tipo viaje',
            align: "center",
            dataIndex: 'tipoViaje',
            width: 150,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>{text}</label>
            )
        },
        {
            title: 'Estado',
            align: "center",
            dataIndex: 'estado',
            width: 100,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>{text}</label>
            )
        },
        {
            title: 'Fecha',
            align: "center",
            dataIndex: 'fecha',
            width: 100,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>
                    {getFormattedDate(text)}
                </label>
            )
        },
        {
            title: 'Hora Inicio',
            align: "center",
            dataIndex: 'horaInicio',
            width: 100,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>
                    {getFormattedHours(text)}
                </label>
            )
        },
        {
            title: 'Hora Llegada',
            align: "center",
            dataIndex: 'horaLlegada',
            width: 125,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>
                    {getFormattedHours(text)}
                </label>
            )
        },
        {
            title: 'Centro de costos',
            align: "center",
            dataIndex: 'centroCostos',
            width: 150,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>{text}</label>
            )
        },
        {
            title: 'Tipo de Trayecto',
            align: "center",
            dataIndex: 'tipoTrayecto',
            width: 150,
            render: (text, record) => (
                <label style={{ width: '100%', fontWeight: 'bold', letterSpacing: '1px' }}>{text}</label>
            )
        },
        {
            title: 'Acciones',
            fixed: '',
            align: "center",
            width: 200,
            render: (item, record) => (
                <Tooltip title="Eliminar">
                    <img
                        className="ico"
                        src={iconDelete}
                        alt="avatar"
                        onClick={() => {
                            setShowModal(true);
                            setRecord(record);
                        }}
                    />
                </Tooltip>
            ),
        }
    ];


    // Recorres registros seleccionados para eliminar
    const eliminarSeleccionados = () => {
        if (!selectedRowKeys.length)
            openNotificationWithIcon('error', '¡No hay datos!', '¡Por favor, seleccione uno o más registros a eliminar!');
        else {
            (selectedRowKeys || []).map(async (item) => {
                setRecord(item); // Guardar registro
                await deleteProgramacionRecord(item); // LLamar funcion de eliminar
            });
            setSelectedRowKeys([]); // State clear
        }
    }

    // Save data selected in checked
    const rowSelection = (key, selectedRows) => {
        setSelectedRowKeys(selectedRows); // Guardar data seleccionada
    };

    return (
        <Wrapper>
            <div className="containterTitulo">
                <strong className="titulo">Programaciones</strong>
            </div>

            <div className="containerTable">
                <div className="containerHeaderTable">
                    <div className="containerBtnEliminar">
                        <button type="button" onClick={eliminarSeleccionados} className="btnEliminar">Eliminar</button>
                    </div>
                    <div className="containerCalendarFilter">
                        <DatePicker
                            format="YYYY-MM-DD"
                            className="dataPicker"
                            disabledDate={disabledDate}
                            onChange={onChangeDatePicker}
                        />
                    </div>
                </div>
                <Table
                    columns={columns}
                    data={dataSource}
                    scroll={{ x: 1500 }}
                    rowSelection={rowSelection}
                    loading={loading}
                />
            </div>

            <ConfirmationWithOptions
                show={showModal}
                onCancel={() => setShowModal(false)}
                onOk={() => deleteProgramacionRecord()}
                text={"¿Está seguro de eliminar el registro?"}
                loadingBtn={loadingBtn}
            />
        </Wrapper>
    )

};

export default programacionCrud;

const Wrapper = styled.div`
    width: 100%;
    height: 100vh;

    .containterTitulo {
        text-align: center;
    }

    .containterTitulo .titulo {
        font-size: 20px;
    }

    .containerTable {
        margin: 40px;
    }

    .containerHeaderTable {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .containerBtnEliminar {
        width: 15%;
        margin-left: 20px;
    }

    .btnEliminar {
        text-transform: uppercase;
        color: #fff;
        border-radius: 21px;
        letter-spacing: 2px;
        font-size: 12px;
        padding: 0;
        line-height: 3em;
        background: #ED7201;
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
        border: none;
        width: 80%;
    }

    .containerCalendarFilter {
        margin-right: 20px;
    }

    .dataPicker {
        width: 100%;
    }

    img {
        height: 25px;
        width: 25px;
        cursor: pointer;
    }
`;



// WEBPACK FOOTER //
// ./src/Components/Programacion CRUD/index.js